import '../node_modules/bootstrap/dist/css/bootstrap.css';
import './App.css';

import { createContext, useState,useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';

import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import PrivateRoutes from '../src/PrivateRoutes';
import ErrorPageNotFound from './components/ErrorPageNotFound';
import { HeaderComponent } from './components/HeaderComponent';
import { HomeComponent } from './components/HomeComponent';
import { QuizComponent } from './components/QuizComponent';
import { ResultComponent } from './components/ResultComponent';
import { WaitingRoom } from './components/WaitingRoom';
import { loadPopup } from './Utils/LoginUtils';
import DeviceTest from './components/DeviceTest';
import FeedbackForm from './components/FeedbackForm';


export const Store = createContext();


// if (document.addEventListener) {
//   document.addEventListener('contextmenu', function (e) {
//     e.preventDefault();
//     loadPopup('Restricted Access!');
//   }, false);
//   document.addEventListener('keydown', (event) => {
//     console.log(JSON.stringify(event));
//     if (event.key === 'F12') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     } else if (event.key === 'F5') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     }
//     else if (event.ctrlKey && event.shiftKey && event.code === 'KeyR') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     } else if (event.ctrlKey && event.shiftKey && event.code === 'KeyI') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     } else if (event.ctrlKey && event.shiftKey && event.code === 'KeyJ') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     } else if (event.ctrlKey && event.code === 'KeyU') {
//       event.preventDefault();
//       loadPopup('Restricted Access!');
//     } else if (event.ctrlKey && (event.code === 'KeyC' || event.code === 'KeyV')) {
//       event.preventDefault();
//       toast.error("Don't Copy/Paste, you will be disqualified", {
//         position: "top-center",
//         autoClose: 1500,
//         hideProgressBar: true,
//         closeOnClick: true,
//         pauseOnHover: false,
//         draggable: false,
//         progress: undefined,
//         theme: "light",
//       });
//     }
//   }, false);
// }

function App() {
  const [data, setData] = useState(null);
  const [isCameraActivestore, setIsCameraActivestore] = useState(false);
  const [isMicActivestore, setIsMicActivestore] = useState(false);

  
  return (
    <DeviceTest>
    <Store.Provider value={{ data, setData,isCameraActivestore, setIsCameraActivestore, isMicActivestore, setIsMicActivestore }}>
      <Router basename='vtaTest'>
        <HeaderComponent />
        <Routes>
          <Route element={<PrivateRoutes />}>
            <Route path='/question' element={<QuizComponent />} />
            <Route path='/preTestTimer' element={<WaitingRoom />} />
            <Route path='/startTest' element={<QuizComponent />} />
            <Route path='*' element={<ErrorPageNotFound />} />
            <Route path='/testResult' element={<ResultComponent />} />
            <Route path='/feedback' element={ <FeedbackForm/>}/>
          </Route>
          <Route path='/' element={<HomeComponent />} />
        </Routes>
        {/* <FooterComponent /> */}
        <ToastContainer />
      </Router>
    </Store.Provider>
    </DeviceTest>
  );
}

export default App;